import Web3 from 'web3';
import { AbiItem } from 'web3-utils';
import Utils from '../common/utils';

export default class Web3Nova {
  httpWeb3: Web3;

  public constructor(chain: string) {
    this.httpWeb3 = new Web3(new Web3.providers.HttpProvider(Utils.getHttpProvider(chain)));
  }

  public getLatestBlockNumber():Promise<number> {
    return this.httpWeb3.eth.getBlockNumber();
  }

  public getTokenUri(address:string, standard:string, tokenId:string):Promise<any> {
    console.log(standard);

    const contract = new this.httpWeb3.eth.Contract(
      Utils.getContractABI(standard) as AbiItem[],
      address,
    );

    if (standard.toLowerCase() === 'erc1155') {
      return contract.methods.uri(tokenId).call({});
    }

    return contract.methods.tokenURI(tokenId).call({});
  }
}
